import { useList } from "@pankod/refine-core";

export default function useMySelect({
  resource,
  metaData,
  config,
  optionLabel,
  optionValue,
  optionType,
}) {
  const { data: data } = useList({ resource, metaData, config });
  // console.log(data)

  if (data) {
    return data.data.map((item) => {
      return {
        label: item[optionLabel],
        value: item[optionValue],
        type: optionType.accessor
          ? item[optionType.type][optionType.accessor]
          : item[optionType.type],
      };
    });
  } else {
    return undefined;
  }
}
